import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { clickAsLink } from 'helpers/link_helpers';

import { getSelectedCompanyIds } from '../../store/selectors/select_list';

const minRecordsForMerge = 2;
const maxRecordsForMerge = 5;

export function MergeButton({ selectedIds }) {
  const canMerge = () => {
    return selectedIds.length >= minRecordsForMerge && selectedIds.length <= maxRecordsForMerge;
  };

  const handleMergeCompanies = (e) => {
    const idString = JSON.stringify(selectedIds);
    const uriString = encodeURIComponent(window.location.href);
    const linkUrl = `/contacts/companies/merge?company_ids=${idString}&redirect_to=${uriString}`;

    clickAsLink(window, linkUrl, e);
  };

  return (
    <button
      className="btn btn-default"
      disabled={!canMerge()}
      name="merge-button"
      onClick={handleMergeCompanies}
    >
      Merge Companies
    </button>
  );
}

MergeButton.propTypes = {
  selectedIds: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
  selectedIds: getSelectedCompanyIds(state)
});

export default connect(mapStateToProps)(MergeButton);
